module.exports = __webpack_public_path__ + "img/ic_home_totok.fbce05c4.png";